import {
  createContext,
  useContext,
  useState
} from "react";
import { initialSnackbarMessage } from "src/utils/formUtil";

const SnackbarContext = createContext(undefined);

export const SnackbarProvider = ({ children }) => {
  const [snackbarMessage, setSnackbarMessage] = useState({ ...initialSnackbarMessage });

  const handleSnackbarClose = () => setSnackbarMessage({ ...initialSnackbarMessage })

  const showSnackbar = ({message, type = "success"}) => {
    setSnackbarMessage({ open: true, message, type })
  };

  return (
    <SnackbarContext.Provider value={{ snackbarMessage, showSnackbar, handleSnackbarClose }}>
      {children}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);

  if (!context) {
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  }

  return context;
}